/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Networks_List_TitleInputs */

const fr_networks_list_title = /** @type {(inputs: Networks_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données des réseaux`)
};

const en_networks_list_title = /** @type {(inputs: Networks_List_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Network data`)
};

/**
* | output |
* | --- |
* | "Network data" |
*
* @param {Networks_List_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const networks_list_title = /** @type {((inputs?: Networks_List_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Networks_List_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_networks_list_title(inputs)
	return en_networks_list_title(inputs)
});